const TRANSITIONS = {
    fade: 'fade',
    slide: 'fade',
    shutdown: 'shutdown',
};

export { TRANSITIONS as T };
